<div class='MessageViewer d-flex flex-column p-5'>
  <div class='MessageViewer-info'>
    <div *ngIf='message.from' class='flex-grow-1'>
      <p *ngIf='!message.editFrom'><b>From: </b><span appCopyText='true'>{{ message.from }}</span></p>
      <p *ngIf='message.editFrom'>
        <b>From: </b
        ><a
        [queryParams]='{ no_email: true, fromMessage: message.message_id }'
        [routerLink]='getContactRoute()'
        appCopyText='true'
        style='color: #0d6efd !important'
      >{{ message.from }}</a
      >
      </p>
    </div>
    <div *ngIf='message.to' class='flex-grow-1'>
      <p *ngIf='!message.editTo'><b>To: </b><span appCopyText='true'>{{ message.to }}</span></p>
      <p *ngIf='message.editTo'>
        <b>To: </b
        ><a
        [queryParams]='{ no_email: true, fromMessage: message.message_id }'
        [routerLink]='getContactRoute()'
        appCopyText='true'
        style='color: #0d6efd !important'
      >{{ message.to }}</a
      >
      </p>
    </div>
    <div *ngIf='message.subject' class='flex-grow-1'>
      <p><b>Subject: </b>{{ message.subject }}</p>
    </div>
    <div *ngIf='message.created_at' class='flex-grow-1'>
      <p>
        <b>Date: </b
        >{{ message.created_at | timezone: 'MM/DD/YY hh:mm a' : sessionData.time_zone }}
      </p>
    </div>
    <div *ngIf='message.recepients' class='flex-grow-1'>
      <p><b>All Recipients: </b>{{ getRecipients() }}</p>
    </div>
    <div *ngIf='message.cc_to' class='flex-grow-1'>
      <p><b>CC: </b>{{ message.cc_to }}</p>
    </div>
    <div *ngIf='message.release_note && showReleaseNote' class='flex-grow-1'>
      <div class='MessageViewer-body red-border mt-3 p-5'>
        <p class='text-danger font-weight-bolder'>Release note:</p>
        <app-html-viewer [html]='message.release_note'></app-html-viewer>
      </div>
    </div>
  </div>
  <div
    *ngIf='message.release_note && sessionData.vsm_id && !message.read_status && showReleaseNote'
    class='MessageViewer-from_manager'>
    <p>
      Message from Manager:
      <b *ngIf='message.updated_note'>{{ message.updated_note }}</b>
    </p>
    {{ message.release_note }}
  </div>
  <div *ngIf='message.updated_flag' class='MessageViewer-body mt-3 p-3'>
    <div class='MessageViewer-body-content'>
      <p class='text-danger font-weight-bolder mb-0'>Message updated</p>
    </div>
  </div>
  <div *ngIf='message.content' class='MessageViewer-body mt-3 p-5'>
    <div class='MessageViewer-body-content'>
      <ng-container *ngIf='asPlainText; else htmlViewer'>
        <div [innerHTML]='getMessageContent()'></div>
      </ng-container>
      <ng-template #htmlViewer>
        <app-html-viewer [html]='getMessageContent()'></app-html-viewer>
      </ng-template>
    </div>
    <div
      *ngIf='message.attachements && message.attachements.length > 0'
      class='MessageViewer-body-attachments'>
      <span
        [popoverAnimation]='true'
        [popoverDisabled]='false'
        [popoverOnHover]='true'
        [popover]='popoverData.body'
        class='MessageViewer-body-attachments-title mb-3'
        popoverPlacement='left'>
        <img
          [alt]="'Attachment Icon'"
          [src]="'/assets/images/attachment icon.png'" />
        <p>Attachments:</p>
      </span>
      <p
        *ngFor='let attachment of message.attachements'
        class='MessageViewer-body-attachments-item'>
        <fa-icon [icon]='iconFile'></fa-icon>
        {{ attachment.file_name }}
      </p>
    </div>
  </div>
</div>
